export default __webpack_public_path__ + "static/media/whatsappSlide9.c76312af.svg";